module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABNElEQVQ4T+1Tv0vDUBD+7qnFwUFpIuYl0D/ASXCyg+AuiLj7axFtoYrQtbuL4CAU/wp3dyuIuLgKwgt9TWs3weYlJylGohEtuHrj3ffdfdx3R/hD0FduT8qlmGgDwEeNmF8nw/B0KgjaWXyOHLjuLYDjcaI4BRrmRTDP2r5f/418Zyu1kAX1PW/ZMK/ZSh3+kwF0HWcdQqy+L2PFUqqUXcyzlOVYiCaYb5I8RdFJsd1+GFrVse05KhQuAEQTxtSmtX7MkhuA2HecsiA6B9GlVqoxDww++dyTcjcWYo/CsGJp3UobdKTcJqIDYUylqPV1ms8dSd9xSpEQiYqWYG5GRGfE/DQA6tL3X370OSkmMqueV42Zdwg4spS6+u4FhpO7rrsFos1Rf2SMuTaj1H1O9qgNEtwblteYEHCmeWMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_t1.png
// module id = j+9T
// module chunks = 85